import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { Formik } from 'formik';
import React from 'react';
import CancelSaveBtns from '../buttons/cancelSaveBtns';

interface IProps {
  open: boolean;
  confirmText: string;
  onClose: () => void;
  onConfirm: (values: any) => void;
  value?: any;
}

const ConfirmDialog: React.FC<IProps> = ({
  open,
  confirmText,
  onClose,
  onConfirm,
  value,
}) => {
  return (
    <Formik
      initialValues={value}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(false);

        onConfirm({ ...value });
      }}
      enableReinitialize={true}
    >
      {(props) => {
        const { isSubmitting, handleSubmit } = props;
        return (
          <Dialog open={true}>
            <DialogTitle>
              <Typography variant='h6'>Confirm</Typography>
            </DialogTitle>
            <DialogContent>
              <form onSubmit={handleSubmit} noValidate>
                <Typography variant='subtitle1'>
                  Are you sure you want to send this notification?
                </Typography>

                <CancelSaveBtns
                  isSubmitting={isSubmitting}
                  onClose={onClose}
                  saveText={confirmText}
                  open={open}
                />
              </form>
            </DialogContent>
          </Dialog>
        );
      }}
    </Formik>
  );
};

export default ConfirmDialog;
